module.exports = __webpack_public_path__ + "img/Mongolia.df1ca914.svg";